interface ValidationProps {
    value: string;
    maxlength?: number;
    minlength?: number;
}

export const validate = ({ value, maxlength=64, minlength=1 }: ValidationProps): string | null => {
    if (value.trim() === '') {
        return `This field is required`;
    }

    if (maxlength && value.length > maxlength) {
        return `This field must be no more than ${maxlength} characters`;
    }

    if (minlength && value.length < minlength) {
        return `This field must be at least ${minlength} characters`;
    }

    return null;
};

interface WordsValidationProps {
    words: string;
    maxWordLength?: number;
    maxWordCount?: number;
}

export const validateWords = ({ words, maxWordLength = 140, maxWordCount = 5000 }: WordsValidationProps): string | null => {
    if (words.trim() === '') {
        return 'This field is required';
    }

    const wordList = words
        .split(/\r?\n/)
        .map((word) => word.trim())
        .filter(Boolean);

    if (wordList.length > maxWordCount) {
        return `Maximum ${maxWordCount} words allowed`;
    }

    const longWord = wordList.find((word) => word.length > maxWordLength);
    if (longWord) {
        return `Each word must be no more than ${maxWordLength} characters`;
    }

    return null;
};

